import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * "Powered by Marakin" footer — fixed to the bottom of the screen (UI tweak
 * #2). Rendered from inside Navbar so every club-facing page gets it
 * automatically. While mounted it adds .has-marakin-footer to <body>, which
 * pads the page bottom (index.css) so content never hides behind the bar.
 */
const MarakinFooter = () => {
  useEffect(() => {
    document.body.classList.add('has-marakin-footer');
    return () => document.body.classList.remove('has-marakin-footer');
  }, []);

  return (
    <div className="marakin-footer">
      <div className="marakin-footer-inner">
        <a href="/" className="marakin-footer-item marakin-footer-link">Powered by Marakin</a>
        <span className="marakin-footer-sep" aria-hidden="true" />
        <Link to="/privacy" className="marakin-footer-item marakin-footer-link">Privacy</Link>
        <span className="marakin-footer-sep" aria-hidden="true" />
        <Link to="/terms" className="marakin-footer-item marakin-footer-link">Terms</Link>
      </div>
    </div>
  );
};

export default MarakinFooter;
